import jwt_decode from 'jwt-decode'
import store from '@/store'
import { roles } from '@/composables/types'

const removeDataTableStates = () => Object.keys(sessionStorage)
                                        .filter(k => /^dt-state/.test(k))
                                        .forEach(k => sessionStorage.removeItem(k))


export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
    },
    {
        path: '/resetear-password/:token', 
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "ResetPassword" */ '../views/ResetPassword.vue')
    },
    {
        path: '/invitacion-acogida',
        name: 'InvitationReception',
        component: () => import(/* webpackChunkName: "InvitationReception" */ '../views/Public/Receptions/InvitationForm.vue')
    },
    {
        path: '/invitacion-acogida/antiguos-alumnos',
        name: 'InvitationReceptionOldStudents',
        component: () => import(/* webpackChunkName: "InvitationReceptionOldStudents" */ '../views/Public/Receptions/InvitationOldStudents.vue')
    },
    {
        path: '/formulario-acogida/:id_invitation/:id_reception/:id_reception_course/:id_reception_category/:form_token',
        name: 'RegisterForm',
        component: () => import(/* webpackChunkName: "RegisterForm" */ '../views/Public/Receptions/RegisterForm.vue')
    },
    {
        path: '/descargar-factura/:id_reception_form/:code_reception',
        name: 'DownloadInvoice',
        component: () => import(/* webpackChunkName: "DownloadInvoice" */ '../views/Public/Receptions/DownloadInvoice.vue')
    },
    {
        path: '/acogida/gracias/:id_reception_form/:code_reception',
        name: 'ThanksReception',
        component: () => import(/* webpackChunkName: "ThanksReception" */ '../views/Public/Receptions/ThanksReception.vue')
    },
    {
        path: '/acogida/error/:id_reception_form/:code_reception',
        name: 'ErrorReception',
        component: () => import(/* webpackChunkName: "ErrorReception" */ '../views/Public/Receptions/ErrorReception.vue')
    },
    {
        path: '/acogida/buscar/',
        name: 'SearchReceptionDNI',
        component: () => import(/* webpackChunkName: "SearchReceptionDNI" */ '../views/Public/Receptions/SearchInvitations.vue'),
        beforeEnter: async(to, from, next) => {
                if (from.name !== 'ViewDetailReception') {
                    removeDataTableStates()
                    sessionStorage.removeItem("dniToSearch")
                }
                next()
            }
    },
    {
        path: '/acogida/visualizar/:id_reception_form/:code_reception',
        name: 'ViewDetailReception',
        component: () => import(/* webpackChunkName: "ViewDetailReception" */ '../views/Public/Receptions/ViewDetailReception.vue'),
    },
    {
        path: '/',
        name: 'home',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
        beforeEnter: async (to, from, next) => {
            try {
                jwt_decode(store.state.auth.token);
                return next()
            } catch(e) {
                store.commit('auth/logout', null, { root: true })
                return next('/login')
            }
        },
        children: [
            {
                path: '',
                name: 'dashboard',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue'),
                beforeEnter: async(to, from, next) => {
                    const currentUser = store.getters['auth/getCurrentUser']
                    if (currentUser.role == "padre") return next('/hijos')
                    next()
                }
            },
            {
                path: '/hijos',
                name: 'dashboardParents',
                component: () => import(/* webpackChunkName: "DashboardParents" */ '../views/DashboardParents.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/hijos/servicios/:id_student',
                name: 'servicesParents',
                component: () => import(/* webpackChunkName: "ServicesParents" */ '../views/Services/ServicesDashboard.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/comedor/hijo/:id_student/:tab?',
                name: 'school_canteen_children',
                component: () => import(/* webpackChunkName: "School_Canteen_Children" */ '../views/School_Canteen/Children.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/comedor/hijo/:id_student/nueva-contratacion',
                name: 'new_school_canteen_children',
                component: () => import(/* webpackChunkName: "New_School_Canteen_Children" */ '../views/School_Canteen/New.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/administrar-comedor',
                name: 'admin_school_canteen',
                component: () => import(/* webpackChunkName: "Admin_School_Canteen" */ '../views/School_Canteen/Admin.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_comedor, roles.tutor, roles.profesor, roles.coordinador_etapa, roles.coordinador_curso, roles.coordinador_patio] }
            },
            {
                path: '/administrar-comedor/pasar-lista',
                name: 'list_school_canteen',
                component: () => import(/* webpackChunkName: "List_School_Canteen" */ '../views/School_Canteen/List.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_comedor, roles.tutor, roles.profesor, roles.coordinador_etapa, roles.coordinador_curso, roles.coordinador_patio] }
            },
            // {
            //     path: '/ruta/hijo/:id_student/:tab?',
            //     name: 'school_route_children',
            //     component: () => import(/* webpackChunkName: "School_Route_Children" */ '../views/School_Route/Children.vue'),
            //     meta: { authorize: [roles.administrador, roles.padre] }
            // },
            // {
            //     path: '/ruta/hijo/:id_student/nueva-contratacion',
            //     name: 'new_school_route_children',
            //     component: () => import(/* webpackChunkName: "New_School_Route_Children" */ '../views/School_Route/New.vue'),
            //     meta: { authorize: [roles.administrador, roles.padre] }
            // },
            // {
            //     path: '/administrar-rutas',
            //     name: 'admin_school_routes',
            //     component: () => import(/* webpackChunkName: "Admin_School_Route" */ '../views/School_Route/Admin.vue'),
            //     meta: { authorize: [roles.administrador, roles.coordinador_ruta, roles.coordinador_patio] },
            //     beforeEnter: async(to, from, next) => {
            //         if (from.name === undefined) removeDataTableStates()
            //         next()
            //     }
            // },
            // {
            //     path: '/administrar-rutas/pendientes',
            //     name: 'pending_school_routes',
            //     component: () => import(/* webpackChunkName: "Pending_School_Route" */ '../views/School_Route/Pendings.vue'),
            //     meta: { authorize: [roles.administrador, roles.coordinador_ruta] }
            // },
            // {
            //     path: '/administrar-rutas/pasar-lista',
            //     name: 'school_route_list',
            //     component: () => import(/* webpackChunkName: "School_Route_List" */ '../views/School_Route/List.vue'),
            //     meta: { authorize: [roles.administrador, roles.coordinador_ruta] },
            // },
            {
                path: '/permanencia/hijo/:id_student/:tab?',
                name: 'school_receptions_children',
                component: () => import(/* webpackChunkName: "School_Receptions_Children" */ '../views/School_Receptions/Children.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/permanencia/hijo/:id_student/nueva-contratacion',
                name: 'new_school_reception_children',
                component: () => import(/* webpackChunkName: "New_School_Receptions_Children" */ '../views/School_Receptions/New.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/administrar-permanencia',
                name: 'admin_school_receptions',
                component: () => import(/* webpackChunkName: "Admin_School_Receptions" */ '../views/School_Receptions/Admin.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_permanencia, roles.coordinador_patio] },
                beforeEnter: async(to, from, next) => {
                    if (from.name === undefined) removeDataTableStates()
                    next()
                }
            },
            {
                path: '/administrar-permanencia/pendientes',
                name: 'pending_receptions',
                component: () => import(/* webpackChunkName: "Pending_Receptions" */ '../views/School_Receptions/Pendings.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_permanencia] }
            },
            {
                path: '/administrar-permanencia/pasar-lista',
                name: 'reception_list',
                component: () => import(/* webpackChunkName: "Reception_List" */ '../views/School_Receptions/List.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_permanencia] },
            },
            {
                path: '/buscar-alumno/:from?',
                name: 'search_student',
                component: () => import(/* webpackChunkName: "SearchStudent" */ '../views/Search/SearchStudent.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_comedor, roles.coordinador_ruta, roles.coordinador_permanencia, roles.secretaria, roles.tutor, roles.profesor, 
                                    roles.coordinador_etapa, roles.coordinador_curso, roles.coordinador_patio, roles.comunicacion, roles.PA, roles.CA, roles.CGA, roles.facturacion] },
                beforeEnter: (to, from, next) => {
                    removeDataTableStates()
                    if (from.name !== 'search_data_student') sessionStorage.removeItem('filtersSearchStudent')
                    return next()
                },
            },
            {
                path: '/ficha-alumno/:id_student/:tab?',
                name: 'search_data_student',
                component: () => import(/* webpackChunkName: "SearchDataStudent" */ '../views/Search/SearchDataStudent.vue'),
                meta: { authorize: [roles.administrador, roles.coordinador_comedor, roles.coordinador_ruta, roles.coordinador_permanencia, roles.secretaria, roles.tutor, roles.profesor, 
                                    roles.coordinador_etapa, roles.coordinador_curso, roles.coordinador_patio, roles.comunicacion, roles.PA, roles.CA, roles.CGA, roles.facturacion] },
            },
            {
                path: '/facturacion/hijo/:id_student',
                name: 'ChildrenBilling',
                component: () => import(/* webpackChunkName: "ChildrenBilling" */ '../views/Billing/Children.vue'),
                meta: { authorize: [roles.padre] },
                beforeEnter: async(to, from, next) => {
                    if (from.name !== 'ChildrenReceipt') sessionStorage.removeItem("filtersSearchReceipt")
                    next()
                }
            },
            {
                path: '/facturacion/hijo/:id_student/:id_student_receipt',
                name: 'ChildrenReceipt',
                component: () => import(/* webpackChunkName: "ChildrenReceipt" */ '../views/Billing/Receipt.vue'),
                meta: { authorize: [roles.padre] }
            },
            {
                path: '/solicitar-cambio/hijo/:id_student/peticiones',
                name: 'ChildrenRequest',
                component: () => import(/* webpackChunkName: "ChildrenRequest" */ '../views/Changes/Changes.vue'),
                meta: { authorize: [roles.padre] },
                children: [
                    {
                        path: 'menu',
                        name: 'IndexChanges',
                        component: () => import(/* webpackChunkName: "IndexChanges" */ '../components/Requests/IndexChanges.vue')
                    },
                    {
                        path: 'datos-personales',
                        name: 'ChangeDataPersonal',
                        component: () => import(/* webpackChunkName: "ChangeDataPersonal" */ '../components/Requests/PersonalData.vue')
                    },
                    {
                        path: 'cuenta-bancaria',
                        name: 'ChangeAccountBank',
                        component: () => import(/* webpackChunkName: "ChangeAccountBank" */ '../components/Requests/AccountBank.vue')
                    },
                    {
                        path: 'familia-numerosa',
                        name: 'ChangeLargeFamily',
                        component: () => import(/* webpackChunkName: "ChangeLargeFamily" */ '../components/Requests/LargeFamily.vue')
                    },
                    {
                        path: 'Donante',
                        name: 'ChangeDonante',
                        component: () => import(/* webpackChunkName: "ChangeDonante" */ '../components/Requests/Donante.vue')
                    },
                    {
                        path: 'cambio-de-foto',
                        name: 'NewPhotoProfile',
                        component: () => import(/* webpackChunkName: "NewPhotoProfile" */ '../components/Requests/NewPhoto.vue')
                    }
                ]
                
            },
            {
                path: '/secretaria',
                name: 'IndexSecretary',
                component: () => import(/* webpackChunkName: "IndexSecretary" */ '../views/Secretary/Admin.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria] },
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'DetailReception') {
                        sessionStorage.removeItem('dateReceptionSecretary')
                        removeDataTableStates()
                    }
                    return next()
                },
            },
            {
                path: '/secretaria/datos-personales',
                name: 'SecretaryDataPersonal',
                component: () => import(/* webpackChunkName: "SecretaryDataPersonal" */ '../views/Secretary/ListChangeData.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria] },
            },
            {
                path: '/secretaria/datos-personales/revision/:id_request',
                name: 'ReviseDataPersonal',
                component: () => import(/* webpackChunkName: "ReviseDataPersonal" */ '../views/Secretary/ReviseDataPersonal.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria] },
            },
            {
                path: '/secretaria/acogidas/:id_reception_form/:code_reception',
                name: 'DetailReception',
                component: () => import(/* webpackChunkName: "DetailReception" */ '../views/Secretary/Receptions/DetailReception.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria, roles.facturacion] },
            },
            {
                path: '/secretaria/acogidas/estado/:status',
                name: 'ReceptionsStatus',
                component: () => import(/* webpackChunkName: "ReceptionsStatus" */ '../views/Secretary/Receptions/ReceptionsStatus.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria] },
            },
            {
                path: '/secretaria/buscar-acogida',
                name: 'SearchReceptions',
                component: () => import(/* webpackChunkName: "SearchReceptions" */ '../views/Secretary/Receptions/SearchReceptions.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria, roles.facturacion] },
            },
            {
                path: '/secretaria/autorizaciones/estado/:status',
                name: 'AuthorizationStatus',
                component: () => import(/* webpackChunkName: "AuthorizationStatus" */ '../views/Authorizations/Admin/Status.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria] },
            },
            {
                path: '/alumno/editar/:id_student/:from?',
                name: 'EditStudent',
                component: () => import(/* webpackChunkName: "EditStudent" */ '../views/Student/Edit.vue'),
                meta: { authorize: [roles.administrador, roles.secretaria, roles.facturacion] },
            },
            {
                path: '/parametrizaciones',
                name: 'Parameterizations',
                component: () => import(/* webpackChunkName: "Parameterizations" */ '../views/Parameterizations/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'IndexParameterizations',
                        component: () => import(/* webpackChunkName: "IndexParameterizations" */ '../components/Parameterizations/Menu.vue'),
                        meta: { authorize: [roles.administrador, roles.coordinador_curso] },
                    },
                    {
                        path: 'cursos',
                        name: 'ParameterizationsCourses',
                        component: () => import(/* webpackChunkName: "ParameterizationsCourses" */ '../components/Parameterizations/Courses/Courses.vue'),
                        beforeEnter: async(to, from, next) => {
                            if (from.name !== 'ParameterizationsCourse') sessionStorage.removeItem("filtersCourses")
                            next()
                        },
                        meta: { authorize: [roles.administrador, roles.coordinador_curso] },
                    },
                    {
                        path: 'cursos/:id_course',
                        name: 'ParameterizationsCourse',
                        component: () => import(/* webpackChunkName: "ParameterizationsCourse" */ '../components/Parameterizations/Courses/Course.vue'),
                        meta: { authorize: [roles.administrador, roles.coordinador_curso] },
                    },
                    {
                        path: 'etapas',
                        name: 'ParameterizationsStages',
                        component: () => import(/* webpackChunkName: "ParameterizationsStages" */ '../components/Parameterizations/Stages/Stages.vue'),
                        meta: { authorize: [roles.administrador] },
                    },
                    {
                        path: 'fechas-academias',
                        name: 'AcademyDates',
                        component: () => import(/* webpackChunkName: "AcademyDates" */ '../components/Parameterizations/Academies/Dates/Dates.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        },
                    },
                    {
                        path: 'school-years',
                        name: 'SchoolYears',
                        component: () => import(/* webpackChunkName: "SchoolYears" */ '../components/Parameterizations/SchoolYears/SchoolYears.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        },
                    }
                ]
            },
            {
                path: '/parametrizaciones-acogidas',
                name: 'ParameterizationsReceptionsView',
                component: () => import(/* webpackChunkName: "ParameterizationsReceptionsView" */ '../views/Parameterizations/ReceptionsIndex.vue'),
                children: [
                    {
                        path: 'acogidas',
                        name: 'ParameterizationsReceptions',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptions" */ '../components/Parameterizations/Receptions/Parametrizations/Parametrizations.vue'),
                        meta: { authorize: [roles.administrador] },
                    },
                    {
                        path: 'acogidas/:id_reception',
                        name: 'ParameterizationsReception',
                        component: () => import(/* webpackChunkName: "ParameterizationsReception" */ '../components/Parameterizations/Receptions/Parametrizations/Parametrization.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/:id_reception/curso/:id_reception_course',
                        name: 'ParameterizationsReceptionCourse',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionCourse" */ '../components/Parameterizations/Receptions/Parametrizations/Course.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/documentos',
                        name: 'ParameterizationsReceptionDocuments',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionDocuments" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Documents/Documents.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/filtros',
                        name: 'ParameterizationsReceptionFilters',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionFilters" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Filters/Filters.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/optativas',
                        name: 'ParameterizationsReceptionOpts',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionOpts" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Opts/Opts.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/itinerarios',
                        name: 'ParameterizationsReceptionItineraries',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionItineraries" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Itineraries/Itineraries.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/citas',
                        name: 'ParameterizationsReceptionAppointments',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionAppointments" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Appointments/Appointments.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/correo-nueva-acogida',
                        name: 'ParameterizationsTemplateMail',
                        component: () => import(/* webpackChunkName: "ParameterizationsTemplateMail" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Mails/NewReception.vue'),
                        meta: { authorize: [roles.administrador] },
                    },
                    {
                        path: 'acogidas/maestros/correos',
                        name: 'ParameterizationsReceptionMails',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionMails" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Mails/Mails.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/correos/:id_template_mail',
                        name: 'ParameterizationsReceptionMail',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionMail" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Mails/Mail.vue'),
                        meta: { authorize: [roles.administrador] }
                    },
                    {
                        path: 'acogidas/maestros/categorias',
                        name: 'ParameterizationsReceptionCategories',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionCategories" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Categories/Categories.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                    {
                        path: 'acogidas/maestros/invitaciones',
                        name: 'ParameterizationsReceptionInvitations',
                        component: () => import(/* webpackChunkName: "ParameterizationsReceptionInvitations" */ '../components/Parameterizations/Receptions/Parametrizations/Masters/Invitations/Invitations.vue'),
                        meta: { authorize: [roles.administrador] },
                        beforeEnter: async(to, from, next) => {
                            removeDataTableStates()
                            next()
                        }
                    },
                ]
            },
            {
                path: '/mis-alumnos',
                name: 'MyStudents',
                component: () => import(/* webpackChunkName: "MyStudents" */ '../views/Student/MyStudents.vue'),
                meta: { authorize: [roles.tutor, roles.profesor, roles.coordinador_curso, roles.coordinador_etapa] },
                beforeEnter: async(to, from, next) => {
                    if (from.name !== 'search_data_student') {
                        sessionStorage.removeItem("filtersSearchStudent")
                        sessionStorage.removeItem("pageSelectedGridStudent")
                    }
                    next()
                }
            },
            {
                path: '/autorizaciones/hijo/:id_student',
                name: 'children_authorizations',
                component: () => import(/* webpackChunkName: "Children_Authorizations" */ '../views/Authorizations/Children.vue'),
                meta: { authorize: [roles.administrador, roles.padre] }
            },
            {
                path: '/autorizaciones/hijo/:id_student/:id_authorization',
                name: 'new_authorizations',
                component: () => import(/* webpackChunkName: "New_Authorization" */ '../views/Authorizations/New.vue'),
                meta: { authorize: [roles.administrador, roles.padre,roles.coordinador_comedor, roles.coordinador_ruta, roles.coordinador_permanencia, roles.secretaria, roles.tutor, roles.profesor, 
                                    roles.coordinador_etapa, roles.coordinador_curso, roles.coordinador_patio, roles.comunicacion, roles.PA, roles.facturacion, roles.CGA, roles.CA] }
            },
            {
                path: '/administrar-autorizaciones',
                name: 'adminAuthorizations',
                component: () => import(/* webpackChunkName: "AdminAuthorizations" */ '../views/Authorizations/Admin/Admin.vue'),
                meta: { authorize: [roles.administrador] },
            },
            {
                path: '/administrar-autorizaciones/:id_authorization',
                name: 'editAuthorizations',
                component: () => import(/* webpackChunkName: "EditAuthorizations" */ '../views/Authorizations/Admin/Edit.vue'),
                meta: { authorize: [roles.administrador] },
            },
            {
                path: '/consultar-enfermeria',
                name: 'manageHospital',
                component: () => import(/* webpackChunkName: "manageHospital" */ '../views/Hospital/Admin/Index.vue'),
                meta: { authorize: [roles.administrador, roles.tutor, roles.coordinador_etapa, roles.coordinador_curso] },
            },
            {
                path: '/asistencia-academias',
                name: 'AssistanceAcademies',
                component: () => import(/* webpackChunkName: "AssistanceAcademies" */ '../views/Academies/Assistance/Index.vue'),
                meta: { authorize: [roles.administrador, roles.CGA, roles.CA, roles.PA] },
            },
            {
                path: '/recuperacion-dias',
                name: 'AcademiesRecoveryDays',
                component: () => import(/* webpackChunkName: "AcademiesRecoveryDays" */ '../views/Academies/Assistance/RecoveryDays.vue'),
                meta: { authorize: [roles.administrador, roles.CGA, roles.CA, roles.PA] },
            },
            {
                path: '/closing',
                name: 'closingSession',
                beforeEnter: async(to, from, next) => {
                    await store.dispatch('auth/signOut')
                    return next('/login')
                }
            }
        ]
    },
    { path: "/:pathMatch(.*)*", redirect: '/' }
]
